import { coreService } from "../../../../services/coreService";
import { buildQuery } from "../../../../lib/network";

export const deleteInspectionById = (headers: any, id: number) => () => {
  return buildQuery(
    coreService.inspectionsDelete(id, {
      headers: {
        ...headers,
        "Content-Type": "text/plain",
      },
    }),
    (response) => {
      return response.data;
    },
  );
};
